import React, { useState, useEffect } from "react";
import { useParams, Navigate } from "react-router-dom";
import { Container as ContainerBase } from "components/misc/Layouts";
import {
  CallApiFetchAuthorized,
  CallApiFetchAuthorized as CallApiPostAuthorized,
  CallApiDeleteAuthorized
} from "helpers/CallApiFetch";
import tw from "twin.macro";
import styled from "styled-components";
import AdminHeader from "pages/Admin/Header.js";
import Select from "react-select";

const Container = tw(ContainerBase)`min-h-screen bg-primary-900 text-white font-medium flex justify-center`;
const Content = tw.div`max-w-screen-xl m-0 sm:mx-1 sm:my-8 bg-white text-gray-900 shadow sm:rounded-lg flex justify-center flex-1`;
const MainContainer = tw.div`p-6 sm:p-12`;
const MainContent = tw.div`mt-4 flex flex-col items-center`;
const Heading = tw.h1`text-2xl xl:text-3xl font-extrabold items-center flex`;

const Form = tw.form`mx-auto max-w-xs pt-8`;
const TextArea = tw.textarea`w-full px-6 py-4 rounded-lg font-medium bg-gray-100 border border-gray-200 text-sm mt-5`;

const SubmitButton = tw.button`mt-5 font-semibold bg-primary-500 text-gray-100 w-full py-4 rounded-lg`;
const CancelButton = tw.button`mt-3 font-semibold bg-red-500 text-white w-full py-4 rounded-lg hover:bg-red-700`;
const FormItem = tw.div`mt-5 mb-4`

const Error = tw.p`font-medium bg-red-300 text-center p-4 mt-8`;

const StyledSelect = styled(Select)`
  ${tw`mt-5`}
`;

export default ({ a14n = null }) => {
  const { secret } = useParams();

  const [error, setError] = useState(false);
  const [redirect, setRedirect] = useState(false);

  const [discounts, setDiscounts] = useState([]);
  const [selectedDiscount, setSelectedDiscount] = useState(null);
  const [adminNote, setAdminNote] = useState("");

  const [ticketHasDiscount, setTicketHasDiscount] = useState(false);

  /* --- загрузка --- */

  useEffect(() => {
    loadDiscounts();
    loadTicket();
    // eslint-disable-next-line
  }, [a14n.token]);

  function loadDiscounts() {
    CallApiFetchAuthorized("/api/discounts", null, a14n.token)
      .then((result) => {
        if (result.data) {
          const opts = result.data.map((d) => ({
            value: d.id,
            label: `${d.name} (${d.percent}%)`,
          }));
          console.log(opts);
          setDiscounts(opts);
        } else {
          setError(result.message);
        }
      });
  }

  function loadTicket() {
    CallApiFetchAuthorized("/api/tickets/" + secret, null, a14n.token)
      .then((result) => {
        if (!result.success) {
          setError(result.message);
          return;
        }

        const ticket = result.data;

        if (ticket.discount) {
          setTicketHasDiscount(true);

          setSelectedDiscount({
            value: ticket.discount.discount_id,
            label: `${ticket.discount.name} (${ticket.discount.percent}%)`,
            discount: ticket.discount,
          });

          setAdminNote(ticket.discount.admin_notes || "");
        }
      });
  }

  /* --- submit --- */

  function SubmitHandler(e) {
    e.preventDefault();

    if (!selectedDiscount) {
      setError("Выберите скидку");
      return;
    }

    const payload = {
      ticket_secret: secret,
      discount_id: selectedDiscount.value,
      admin_notes: adminNote,
    };

    CallApiPostAuthorized("/api/tickets/discounts/" + secret, payload, a14n.token)
      .then((result) => {
        if (result.success) {
          setRedirect("/ticket/" + secret);
        } else {
          setError(result.message);
        }
      });
  }

  function CancelHandler() {
    if (!window.confirm("Отменить скидку?")) return;

    CallApiDeleteAuthorized("/api/tickets/discounts/" + selectedDiscount.discount.id, a14n.token)
      .then((result) => {
        if (result.success) {
          setRedirect("/ticket/" + secret);
        } else {
          setError(result.message || "Ошибка отмены");
        }
      });
  }

  return (
    <>
      <AdminHeader a14n={a14n} />

      <Container>
        <Content>
          <MainContainer>
            <MainContent>
              {redirect && <Navigate to={redirect} />}

              <Heading>Скидка на абонемент</Heading>

              <Form onSubmit={SubmitHandler}>
                <StyledSelect
                  options={discounts}
                  value={selectedDiscount}
                  onChange={setSelectedDiscount}
                  placeholder="Выберите скидку..."
                />

                <TextArea
                  placeholder="Комментарий администратора"
                  value={adminNote}
                  onChange={(e) => setAdminNote(e.target.value)}
                />

                {
                  ticketHasDiscount && selectedDiscount.discount && (
                    <FormItem>Активирована: {selectedDiscount.discount?.created_at}</FormItem>
                  )
                }

                <SubmitButton>
                  {ticketHasDiscount ? "Сохранить" : "Активировать"}
                </SubmitButton>

                {ticketHasDiscount && (
                  <CancelButton type="button" onClick={CancelHandler}>
                    Отменить скидку
                  </CancelButton>
                )}

                {error && <Error>{error}</Error>}
              </Form>
            </MainContent>
          </MainContainer>
        </Content>
      </Container>
    </>
  );
};
